import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import AuthService from 'cio/services/auth';
import CustomerModel from 'cio/models/customer';

const ENABLE_SEARCH_AFTER = 10;

export default class AttributesIndexController extends Controller {
  @service auth!: AuthService;

  declare model: CustomerModel;

  searchTerm = '';

  @computed('model.filteredAttrsWithIdentifiers.[]')
  get searchEnabled() {
    return this.model.filteredAttrsWithIdentifiers.length >= ENABLE_SEARCH_AFTER;
  }

  @computed('model.filteredAttrsWithIdentifiers.[]', 'searchTerm')
  get matchedAttrs() {
    let trimmedSearchTerm = this.searchTerm.trim();

    if (!trimmedSearchTerm) {
      return this.model.filteredAttrsWithIdentifiers;
    }

    return this.model.filteredAttrsWithIdentifiers.filter((attr: Record<string, string>) => {
      let [key] = Object.keys(attr);

      return key.includes(trimmedSearchTerm);
    });
  }

  get canEditAttributes() {
    return this.auth.hasPermission('journeys/people/edit');
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'person.attributes.index': AttributesIndexController;
  }
}
